import { Pipe, PipeTransform } from '@angular/core';
import { ContainerActivityService } from '../../common/_services/containerActivity.service';

@Pipe({
  name: 'walletcontainer',
  pure: true,
  standalone: false,
})
export class WalletcontainerPipe implements PipeTransform {
  constructor(private containerActivityService: ContainerActivityService) {}

  transform(value: any): any {
    if (!value || value === undefined) {
      return null;
    }

    const sumsize = this.containerActivityService.getWalletSizeByContainerId(+value);
    if (sumsize) {
      return sumsize.toFixed(2);
    } else {
      return null;
    }
  }
}
